import images from "@assets/images";
import { AuthContext } from "@src/AuthProvider";
import colors from "@src/theme/colors";
import React from "react";
import { ActivityIndicator, Image, Pressable, StyleSheet, Text } from "react-native";
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";

const AnimatedButton = Animated.createAnimatedComponent(Pressable);

const ImageButton06 = (props: any) => {
  const animated = useSharedValue(1);
  const { handleClick } = React.useContext(AuthContext);
  const { style, source, onPress, disabled, scaleSize, isLoading, labelStyle } = props;

  const onPressIn = () => {
    animated.value = withTiming(scaleSize || 0.95, { duration: 100 });
  };

  const onPressOut = () => {
    animated.value = withTiming(1, { duration: 100 });
  };

  const onClick = () => {
    onPress();
    handleClick();
  };

  const animateStyle = useAnimatedStyle(() => {
    return {
      transform: [{scale: animated.value}],
    };
  }, []);

  return (
    <AnimatedButton
      onPress={onClick}
      disabled={disabled}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      style={[styles.buttonStyle, style, animateStyle]}
    >
      <Image
        source={source || images["btn-small"]}
        style={styles.imageButtonStyle}
        resizeMode="stretch"
      />
      {isLoading ? (
        <ActivityIndicator
          style={styles.spinner}
          color={colors.white}
          size="small"
          animating
        />
      ) : <Text selectable={false} style={[styles.t_label, labelStyle]}>{props.label}</Text>}
      
    </AnimatedButton>
  );
};

const styles = StyleSheet.create({
  buttonStyle: {
    width: "40%",
    height: 70,
    alignItems: "center",
    justifyContent: "center",
  },
  imageButtonStyle: {
    width: "100%",
    height: "100%",
  },
  t_label: { 
    fontFamily: "Roboto-Bold", 
    color: colors.white, 
    position: "absolute",
    marginBottom: "2%",
  },
  spinner: { position: "absolute", zIndex: 1 },
});

export default ImageButton06;
